import { useEffect } from "react";
import { useLogs } from "../../hooks/useLogs";
import AssetPlayer from "./AssetPlayer";
import LayoutPlayer from "./LayoutPlayer";
import PlaylistPlayer from "./PlaylistPlayer";
import VideoPlayer from "./VideoPlayer";
import AnimatingGradientBackground from "./components/AnimatingGradientBackground";
import { SignageContentPlayerProvider, SignageContentPlayerProviderProps } from "./hooks/ContentPlayerProvider";
import { VideoPlayerRefProvider } from "./hooks/useVideoPlayerRef";
import { CustomScreen } from "./imports";

export function SignageContentPlayer({ screenInfo, ...props }: { screenInfo: CustomScreen | null | undefined } & SignageContentPlayerProviderProps) {
  const { log } = useLogs()
  useEffect(() => {
    // @ts-expect-error
    log({ eventtype: "Journey", name: "ContentPlayer", payload: { hasAsset: !!screenInfo?.asset, hasLayout: !!screenInfo?.layout, hasPlaylist: !!screenInfo?.playlist, hasVideo: !!screenInfo?.video } })
  }, [screenInfo])
  return (
    <SignageContentPlayerProvider {...props}>
      <VideoPlayerRefProvider>
        {screenInfo?.playlist ? (
          <PlaylistPlayer playlist={screenInfo.playlist} screen={screenInfo} />
        ) : screenInfo?.layout ? (
          <LayoutPlayer layoutInfo={screenInfo.layout} />
        ) : screenInfo?.asset ? (
          <AssetPlayer asset={screenInfo.asset} screen={screenInfo} />
        ) : screenInfo?.video ? (
          <VideoPlayer loop url={screenInfo.video.url ?? ""} />
        ) : (
          <div
            className={`relative z-0 flex h-full w-full flex-col items-center justify-center gap-8 overflow-hidden text-[#3d2b24] font-exo`}
            aria-hidden="true"
          >
            <h1 aria-hidden="true" className="text-[calc(4px+7vw)] font-semibold">
              Hi there 👋
            </h1>
            <h2 aria-hidden="true" className="text-center text-[calc(4px+3vw)]">
              Waiting for you to select a design from <br /> your account to
              display here...
            </h2>
            <AnimatingGradientBackground className="absolute -z-10 h-full w-full opacity-50" />
          </div>
        )}
      </VideoPlayerRefProvider>
    </SignageContentPlayerProvider>
  )
}
